<ngx-smart-modal #myModal1 identifier="myModal1">
    <h2 class="modalError">Please login and subscribe to access this content.</h2>
    <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
  </ngx-smart-modal>
  <ngx-smart-modal #myModal2 identifier="myModal2">
    <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
    <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
  </ngx-smart-modal><div class="loadingBox" *ngIf="!loaded">
    <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
   </div>
   <div *ngIf="loaded">
<app-header></app-header>
<div id="wrapper">
    <app-sidebar></app-sidebar>
    <div id="content-wrapper">
        <div class="container-fluid upload-details">
            <div class="row">
                <div class="col-lg-12">
                    <div class="main-title">
                       
                    </div>
                </div>
            </div>
            <div class="row accountDetailsBox">
                <div class="col-md-8">
                    <h3 class="inputHeading"><i class="fas fa-fw fa-user"></i> Account ({{profileData.phoneNumber}})</h3>
                    <div class="accountDetails">
                        <div class="inputHolder">
                        <span class="accountLabel">Name:</span>
                        <input class="accountInput" *ngIf="!setName" [value]="profileData.name" readonly> <i *ngIf="!setName"  (click)="setNameToggle()" class="fas fa-fw fa-pen accountSaveIcon"></i>
                        <input class="accountInputEdit" *ngIf="setName" (change)="onNameKeyUp($event)" [value]="profileData.name"> <a class="accountSave" *ngIf="setName" (click)="changeAccountInfoName()">SAVE</a>
                        </div>
                        <div class="inputHolder">
                        <span class="accountLabel">Email:</span>
                        <input class="accountInput" *ngIf="!setEmail" [value]="profileData.email" readonly> <i *ngIf="!setEmail"  (click)="setEmailToggle()" class="fas fa-fw fa-pen accountSaveIcon"></i>
                        <input class="accountInputEdit" *ngIf="setEmail" (change)="onEmailKeyUp($event)" [value]="profileData.email"> <a class="accountSave"  *ngIf="setEmail" (click)="changeAccountInfoEmail()">SAVE</a>
                    </div>
                    <div class="inputHolder">
                        <span class="accountLabel">Mobile Number:</span>
                        <input class="accountInput"  [value]="profileData.phoneNumber" readonly>
                     </div>
                     <div class="inputHolder">
                        <span class="accountLabel">Mobile Operator:</span>
                        <input class="accountInput"  [value]="mobOperator" readonly>
                     </div>
                    </div>

                </div>
                <div class="col-md-4">


                </div>
                <div class="col-md-8">

                    </div>
               
            </div>
            <div class="row accountDetailsBox">
                <div class="col-md-8">
                    <h3 class="inputHeading"><i class="fas fa-fw fa-video"></i> Subscriptions </h3>
                    <div class="unsubDiv" *ngFor="let channel of mysubs.subscriptions; let i=index;">
                    <div class="subscriptionBox">
                        <span class="subLabel">{{channel.channelName}} {{channel.siteName}}</span>
                    </div>
                    <button class="subButton" routerLink="/unsubscribe/{{channel.id}}">Unsubscribe</button>
                </div>
                <div *ngIf="(mysubs | json) == '{}'" class="p-4">
                     <h3 i18n="@@You are not subscribed to any channels or sites | Message shown when user is not subscribed to anything">You are not subscribed to any channels or sites.</h3>
                     <div style="height: 10px; width: 100%;"></div>
                     <a i18n="@@View Channels | View Channels Button"  href="/channels"  class="unsubbutton white-outline-button">View Channels</a>
                 </div>
            </div>
        </div>
        </div>
    </div>
</div>
<div class="container-slider">
        <div class="navbarbottom">
          <a routerLink="/"><i _ngcontent-c3="" class="fas fa-fw fa-home"></i> <span class="homeFooterLink" i18n="@@Footer Home Link">Home</span></a>
          <a routerLink="/my-list"><i _ngcontent-c3="" class="fas fa-fw fa-list"></i> <span class="myListFooterLink" i18n="@@Footer My List Link">My List</span></a>
 
        </div>
        </div>
        </div>